import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import Category from '../components/Category.vue'
import Product from '../components/Product.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/category',
      name: 'Category',
      component: Category,
    },
    {
      path: '/product',
      name: 'Product',
      component: Product,
    },
  ],
})

export default router
